import { type Components, type Theme } from "@mui/material/styles";

import { type BadgeSize } from "../../components/Badge";

declare module "@mui/material/Badge" {
  interface BadgeOwnProps {
    size?: BadgeSize;
  }
}

export const muiBadgeOverrides: Components<Theme> = {
  MuiBadge: {
    defaultProps: {
      size: "medium",
    },
    styleOverrides: {
      badge: ({ theme }) => ({
        borderWidth: theme.borderWidth?.thick,
        borderStyle: "solid",
        color: theme.palette.text.invert,
        borderColor: theme.palette.base?.base,
        backgroundColor: theme.palette.background.default,
        boxSizing: "content-box",
        variants: [
          {
            props: { size: "small" },
            style: {
              minWidth: "0.625rem",
              height: "0.625rem",
              padding: 0,
              // these aren't part of the design system so hardcoding them
              fontSize: "8px",
            },
          },
          {
            props: { size: "medium" },
            style: {
              minWidth: "0.75rem",
              height: "0.75rem",
              padding: 0,
              // these aren't part of the design system so hardcoding them
              fontSize: "10px",
            },
          },
        ],
      }),
    },
  },
};
